import CtaCard from '@stories/Components/Cards/CtaCard/CtaCard';
import React from 'react';
import { CtaCardsStyles as S } from './CtaCards.styles';
const CtaCards = ({ firstItemFeatured = false, hideAllDescriptions = false, id, items, }) => {
    return (React.createElement(S.Container, { "data-featured": firstItemFeatured, id: id, "data-hide-descriptions": hideAllDescriptions },
        React.createElement(S.Inner, null, items &&
            items.map((item, index) => firstItemFeatured && index === 0 ? (React.createElement(CtaCard, { key: `item-${index}`, ...item, firstFeatured: firstItemFeatured })) : (React.createElement(CtaCard, { key: `item-${index}`, ...item }))))));
};
export default CtaCards;
